import { render } from "./error500.vue?vue&type=template&id=10258b75"
import script from "./error500.vue?vue&type=script&lang=js"
export * from "./error500.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__